import React, { useState } from 'react';
import { Card, CardBody, Col, Container, Input, Label, Row, Button, Form, Spinner } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux'
import { login } from '../store/actions/authActions';
function Login() {
    const [userName, setUserName] = useState('');
    const [password, setPassword] = useState('');
    const dispatch = useDispatch()
    const { loading, notification } = useSelector(state => state.auth)
    return (
        <>
            <Container className="mt-5 mb-4">
                <Row className="justify-content-center">
                    <Col lg="8">
                        <Card className="auth-card text-center">
                            <CardBody className="auth-card-body">
                                <Form
                                    onSubmit={e => {
                                        e.preventDefault()
                                        let obj = {
                                            username: userName,
                                            password: password
                                        }
                                        dispatch(login(obj))
                                    }}
                                >
                                    <p className="auth-title">Sign in</p>
                                    <p className="auth-subtitle ">Enter Username & Password to Login</p>
                                    <Label className="auth-label mt-5 mb-0">Username</Label>
                                    <Input
                                        type="text"
                                        placeholder='username'
                                        className="auth-input mt-2"
                                        required
                                        value={userName}
                                        onChange={e => setUserName(e.target.value)}
                                    />
                                    <Label className="auth-label mt-5 mb-0">Password</Label>
                                    <Input
                                        type="password"
                                        placeholder='password'
                                        className="auth-input mt-2"
                                        required
                                        value={password}
                                        onChange={e => setPassword(e.target.value)}
                                    />
                                    <Button className="auth-btn mt-5" color="primary" type='submit'>
                                        {loading ? <Spinner size="sm" /> : 'Login'}
                                    </Button>
                                    {
                                        notification != ''
                                        &&
                                        <p className="error mx-auto mt-3 mb-0">
                                            Invalid Credentials
                                        </p>
                                    }
                                </Form>
                                <br />
                                <Label className="text-center mt-2">
                                    Don't have an account yet? <b>Sign Up</b>
                                </Label>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default Login;
